import { MultiSelectCombobox, SelectOption } from '@/components/form-components/MultiSelectCombobox'
import { REQUEST_STATUS_LABELS, REQUEST_TICKET_TYPE_LABELS } from '@/pages/Subscriptions/Requests/types'
import { Table } from '@tanstack/react-table'
import { RestSchemas } from '@/contexts/QueryProvider'

type ExistingRequest = RestSchemas['Messages.Requests.ExistingRequest']

const ticketTypeOptions: SelectOption<number>[] = Object.entries(REQUEST_TICKET_TYPE_LABELS).map(([value, label]) => ({
  value: Number(value),
  label,
}))

const statusOptions: SelectOption<number>[] = Object.entries(REQUEST_STATUS_LABELS).map(([value, label]) => ({
  value: Number(value),
  label,
}))

type PlatformTicketRequestsFiltersProps = {
  table: Table<ExistingRequest>
}

export function PlatformTicketRequestsFilters({ table }: PlatformTicketRequestsFiltersProps) {
  const selectedTypes = ((table.getColumn('ticketType')?.getFilterValue() as number[] | undefined) ?? []).filter(
    (value) => value != null
  )
  const selectedStatuses = ((table.getColumn('status')?.getFilterValue() as number[] | undefined) ?? []).filter(
    (value) => value != null
  )

  return (
    <div className="flex gap-3">
      <div className="w-52">
        <MultiSelectCombobox
          triggerClassName="h-9"
          renderBadgesInTrigger
          options={ticketTypeOptions}
          selectedValues={selectedTypes}
          onSelectionChange={(values) =>
            table.getColumn('ticketType')?.setFilterValue(values.length > 0 ? values : undefined)
          }
          placeholder="By type"
          searchPlaceholder="Search types..."
          emptyMessage="No types found."
        />
      </div>
      <div className="w-52">
        <MultiSelectCombobox
          triggerClassName="h-9"
          renderBadgesInTrigger
          options={statusOptions}
          selectedValues={selectedStatuses}
          onSelectionChange={(values) =>
            table.getColumn('status')?.setFilterValue(values.length > 0 ? values : undefined)
          }
          placeholder="By status"
          searchPlaceholder="Search statuses..."
          emptyMessage="No statuses found."
        />
      </div>
    </div>
  )
}
